import React from "react";
import { scroller } from "react-scroll";

import Image from '../../../components/Image';
import { getImageName } from "../../../api/iposApi";
import { isMobileAndTablet } from "../../../helpers/common";

export const GroupItem = ({ groupItem, visibleSection, menuPresentation, branchInfo }) => {
  const sectionName = `section_${groupItem.menu_item_id}`;
  const isMobile = isMobileAndTablet();

  const scrollToSection = (e) => {
    e.preventDefault();
    scroller.scrollTo(sectionName, {
      duration: 100,
      offset: 0,
      delay: 0,
      smooth: true,
      containerId: "scrollable-items-container",
    });
  };

  return (
    <li>
      <a
        onClick={scrollToSection}
        data-toggle="collapse"
        data-target="#breakfast"
        name={`${sectionName}-menu`}
        className={`collapsed ${
          visibleSection && visibleSection.section === sectionName
            ? "active"
            : ""
        } `}
      >
        {!isMobile && (
          <div className={"image-block"}>
            <Image image={getImageName(branchInfo, groupItem)} useDefaultEmpty = {true}/>
          </div>
        )}
        <div className={"description"}>{groupItem.item_name}</div>
      </a>
    </li>
  );
};
